<template>
  <div>
    <p>Born 1989<br><br>Jane Bang Stoltze has over 10 years of project coordination experience mainly from the event
      industry.<br><br>In the current position as COO at Loyal Solutions A/S, Jane Bang Stoltze is responsible for every
      aspect of the day-to-day operations and ensuring that clients across the world experience world class performance
      and service.<br><br>Jane Bang Stoltze has been employed since 2015 and has been a member of the executive
      management since 2017.<br><br><strong>Education & Experience</strong><br>Professional Bachelor (PBA) Leisure
      Management, University College Sjælland, Denmark and Mini MBA, Aros Copenhagen, Denmark.<br><br><strong>Other
        current positions</strong><br>None.<br><br><strong>Shareholding in the Company</strong><br>Jane Bang Stoltze
      will over a period of 12 months earn the rights for up to 45.000 warrants. The warrants can be exercised in a
      period from August 2022 up until December 2026.</p>
  </div>
</template>

<script>
  export default {
    name: 'JaneBangDescription',
  }
</script>
